module.exports = __webpack_public_path__ + "img/elementheights_jak.1d470f2c.png";